export const comparePortalDisplayOrder = (entryA, entryB) => {
	const length = Math.min(entryA.orderPath.length, entryB.orderPath.length);
	for(let index = 0; index < length; index++) {
		if(entryA.orderPath[index] !== entryB.orderPath[index]) {
			return entryA.orderPath[index] - entryB.orderPath[index];
		}
	}
	return entryA.orderPath.length - entryB.orderPath.length ||
		entryA.discoveryOrder - entryB.discoveryOrder;
};

const hasAncestor = (display, possibleAncestor) => {
	for(let parent = display?.parent; parent; parent = parent.parent) {
		if(parent === possibleAncestor) return true;
	}
	return false;
};

const displayRootInParent = (display, parent) => {
	let current = display;
	while(current?.parent && current.parent !== parent) current = current.parent;
	return current?.parent === parent ? current : null;
};

export const placePortalBehindDisplays = (portalDisplay, foregroundDisplays = []) => {
	const parent = portalDisplay?.parent;
	if(!parent || portalDisplay.destroyed) return false;

	const foregroundRoots = [...new Set(foregroundDisplays
		.filter(display => display && !display.destroyed)
		.map(display => displayRootInParent(display, parent))
		.filter(display => display && display !== portalDisplay))];
	if(!foregroundRoots.length) return false;

	const portalIndex = parent.getChildIndex(portalDisplay);
	const firstForegroundIndex = Math.min(...foregroundRoots
		.map(display => parent.getChildIndex(display))
		.filter(index => index >= 0));
	if(portalIndex < 0 || !Number.isFinite(firstForegroundIndex)) return false;
	if(portalIndex < firstForegroundIndex) return true;

	parent.addChildAt(portalDisplay, firstForegroundIndex);
	return true;
};

export const portalDisplayOrderPath = (display, renderParent) => {
	const path = [];
	let current = display;
	while(current && current !== renderParent) {
		const parent = current.parent;
		if(!parent) return null;
		path.unshift(parent.getChildIndex(current));
		current = parent;
	}
	return current === renderParent ? path : null;
};

export const getPortalBodyDisplayRoots = (body, renderParent) =>
	[body.mySprite, body.myTexture]
		.filter((display, index, all) => display && !display.destroyed &&
			all.indexOf(display) === index)
		.filter((display, index, all) => !all.some((possibleAncestor, ancestorIndex) =>
			index !== ancestorIndex && hasAncestor(display, possibleAncestor)))
		.map(sourceDisplay => ({
			sourceDisplay,
			orderPath: portalDisplayOrderPath(sourceDisplay, renderParent),
		}))
		.filter(entry => entry.orderPath);
